export function showHideLoadMoreButton(showOrHide, button, grid){
  if (showOrHide) {
    button.hide();
    grid.removeClass('grid--with-gradient');
  } else {
    button.show();
    grid.addClass('grid--with-gradient');
  }
}